import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PermissionTable from "../../components/Table/PermissionTable";
import { useContext } from "react";
import { AddBtn } from "../../components/NewBtn/NewBtn";
import { Context } from "../../Context/Context";
import { Modal } from "../../components/Modal/Modal";

import Save from "../../Assets/Images/save.svg";
import Delete from "../../Assets/Images/delete1.svg";
import toast, { Toaster } from "react-hot-toast";

function PermissionTables() {
  const navigate = useNavigate();
  const { lang } = useContext(Context);
  const env = process.env.REACT_APP_API;
  const [loading, setLoading] = useState(false);
  const token = JSON.parse(window.localStorage.getItem("token"));
  const [changeStatus, setChangeStatus] = useState(false);
  const [totalElement, setTotalElement] = useState(0);
  const [openPermissionModal, setOpenPermissionModal] = useState(false);
  const [editedValue, setEditedValue] = useState("");
  const [nameValue, setNameValue] = useState(null);

  const [messageList, setMessageList] = useState([]);
  useEffect(() => {
    axios
      .get(`${env}cabinet/v2/permission-param`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setLoading(false);
        setMessageList(res.data);
        setTotalElement(res.data.length);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response.status === 401) {
          navigate("/");
          window.localStorage.clear();
          window.sessionStorage.clear();
          window.location.reload();
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeStatus]);

  const handleSave = () => {
    axios
      .post(
        `${env}cabinet/v2/permission-param/create`,
        {
          name: nameValue,
          param: editedValue,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        setEditedValue("");
        setChangeStatus(!changeStatus); // trigger data refresh
        setOpenPermissionModal(false);
        setNameValue("");
        toast.success(
          lang ? "Успешно добавлено!" : "Muvaffaqiyatli qo'shildi!"
        );
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/");
          window.localStorage.clear();
          window.sessionStorage.clear();
          window.location.reload();
        } else if (err.response.status === 406) {
          toast.warning(
            lang ? "Параметр уже существует!" : "Parametr allaqachon mavjud!"
          );
        } else {
          toast.error(lang ? "Ошибка сервера!" : "Server xatosi!");
        }
      });
  };

  return (
    <div className="bg-white p-5 w-full h-full">
      <Toaster position="top-center" reverseOrder={false} />
      <div className=" flex items-center justify-between">
        <div>
          <h2 className="font-bold text-[25px]">{lang ? "" : "Ruxsatlar"}</h2>
          <span className="text-slate-500">
            {totalElement} {lang ? "сообщения" : "ruxsatnoma"}
          </span>
        </div>
        <AddBtn
          onClick={() => {
            setOpenPermissionModal(true);
          }}
          title={lang ? "Добавить" : "Qo'shish"}
        />
      </div>

      <div>
        <PermissionTable
          changeStatus={changeStatus}
          setChangeStatus={setChangeStatus}
          branchList={messageList}
          loading={loading}
        />
      </div>

      {/* Permission Modal */}
      <Modal
        isVisible={openPermissionModal}
        onClose={() => {
          setOpenPermissionModal(false);
          setEditedValue("");
          setNameValue("");
        }}
        title={lang ? "Добавить" : "Qo'shish"}
      >
        <p>{lang ? "Введите название разрешения" : "Ruxsat nomini kiriting"}</p>
        <div className="flex flex-col items-center justify-end gap-2 relative mt-4">
          <div className="w-full flex flex-col space-y-3">
            <input
              type="text"
              value={nameValue}
              onChange={(e) => setNameValue(e.target.value)}
              className="border border-slate-300 rounded px-2 py-1 w-full text-start focus:border-blue-500 outline-none "
              autoFocus
              placeholder={lang ? "Название разрешения" : "Ruxsat nomi"}
            />
            <textarea
              type="text"
              value={editedValue}
              rows={5}
              cols={5}
              onChange={(e) => setEditedValue(e.target.value)}
              className="border border-slate-300 rounded px-2 py-1 w-full text-start focus:border-blue-500 outline-none "
              autoFocus
              placeholder={lang ? "Параметр разрешения" : "Ruxsat parametri"}s
            />
          </div>
          <div className="flex justify-end gap-2 w-full top-0 right-0">
            <button
              onClick={() => handleSave()}
              className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 transition"
            >
              {lang ? "Сохранить" : "Saqlash"}
            </button>
            <button
              className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition"
              onClick={() => {
                setOpenPermissionModal(false);
                setEditedValue("");
                setNameValue("");
              }}
            >
              {lang ? "Отмена" : "Bekor qilish"}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default PermissionTables;
